import { Button } from '../common';
import { useBannerStore, useUIStore } from '../../stores';


interface BannerToolbarProps {
  onClose?: () => void;
}

export function BannerToolbar({ onClose }: BannerToolbarProps) {
  const { resetCanvas } = useBannerStore();

  const { openModal } = useUIStore();

  const handleAddNFT = () => {
    openModal('bannerSearch');
  };

  return (
    <div className="bg-white dark:bg-neutral-900 rounded-xl border border-surface-border dark:border-neutral-800 p-3 mb-4 flex-shrink-0">
      <div className="flex items-center gap-2 justify-end">
        <Button variant="primary" size="sm" onClick={handleAddNFT} className="text-xs sm:text-sm">
          + Add NFT
        </Button>
        <Button variant="secondary" size="sm" onClick={resetCanvas} className="text-xs sm:text-sm">
          Reset
        </Button>
        {onClose && (
          <Button variant="ghost" size="sm" onClick={onClose} className="text-xs sm:text-sm">
            Close
          </Button>
        )}
      </div>
    </div>
  );
}
